import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProgramBuilderMainService } from '../../program-builder-main.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SuccessComponent } from 'src/app/shared/modals/success/success.component';
import { AlertComponent } from 'src/app/shared/modals/alert/alert.component';
import { PostHogService } from 'src/app/shared/services/posthog.service';

@Component({
  selector: 'app-create-program',
  templateUrl: './create-program.component.html',
  styleUrls: ['./create-program.component.scss']
})
export class CreateProgramComponent implements OnInit {

  categories: any = [];
  subCategories: any = [];
  blockLoader: string = 'blockLoader';
  categoryIndex: any;
  jsonData: any = {
    name: '',
    description: '',
    programImage: '',
    landscapeImage: '',
    courseTime: '',
    numberOfSections: 0,
    difficultyLevel: '',
    programMenuCompleted: false,
    category: {
      name: '',
      id: ''
    },
    subCategory: {
      name: '',
      id: ''
    },
    sections: [],
    isPublished: false
  }

  constructor(public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CreateProgramComponent>,
    private _programBuilderMainService: ProgramBuilderMainService,
    private spinner: NgxSpinnerService,
    private postHogService: PostHogService) { }

  ngOnInit(): void {
    this.getCategories();
    // console.log('jsondta', this.jsonData)
  }

  getCategories() {
    // console.log('In organization')
    this._programBuilderMainService.getCategories().subscribe((data: any) => {
      this.categories = data;
      //   console.log(this.categories);
    });

  }

  changeCategory(ev: any) {
    // console.log(ev);
    // console.log(this.jsonData.category);
    this.subCategories = [];
    this.categories.forEach(async (el: any, index: any) => {
      if (el.id === ev) {
        this.categoryIndex = index;
        this.jsonData.category.name = el.name;
        this.jsonData.category.id = el.id;
        await this.getSubCategories(el.subCategories);
      }
    })
  }

  async getSubCategories(subCategories: any) {
    let visibleSubCat: any = [];
    await subCategories.forEach((subCat: any) => {
      if (subCat.visible) {
        visibleSubCat.push(subCat);
      }
      //   console.log(visibleSubCat);
      this.subCategories = visibleSubCat;
    })
  }

  changeSubCategory(ev: any) {
    // console.log(ev);
    this.categories[this.categoryIndex].subCategories.forEach((el: any) => {
      if (el.id === ev) {
        this.jsonData.subCategory.name = el.name;
        this.jsonData.subCategory.id = el.id;
      }
    })
  }

  onClickSection(sectionNumber: any) {
    this.jsonData.sections = [];
    if (sectionNumber > 0) {
      for (let i = 1; i <= sectionNumber; i++) {
        this.jsonData.sections.push({
          sno: i.toString(),
          name: '',
          description: '',
          numberOfUnits: 0,
          type: 'menu',
          menu: [],
        });
      }
    }
  }

  async onFileChange(event: any, type: string) {
    const reader = new FileReader();

    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;

      reader.readAsDataURL(file);

      reader.onload = async () => {
        const base64Response = await fetch(reader.result as string);
        // console.log(base64Response.url)
        if (type === 'programImage') this.jsonData.programImage = base64Response.url;
        else if (type === 'landscapeImage') this.jsonData.landscapeImage = base64Response.url;

      };
      // this.isImage = false;
    }
  }

  validateFields() {
    let isValid = true;
    if (!this.jsonData.name || !this.jsonData.description || !this.jsonData.difficultyLevel || !this.jsonData.courseTime) {
      console.log(',,,,,,,')
      this.dialog.open(SuccessComponent, {
        data: {
          title: "Oops!",
          subTitle: "Please fill all details."
        },
      });
      isValid = false
      this.spinner.hide("blockLoader");
    } else if (!this.jsonData.programImage || !this.jsonData.landscapeImage) {
      //   console.log(',,,,,,,')
      this.dialog.open(SuccessComponent, {
        data: {
          title: "Oops!",
          subTitle: "Please Upload image."
        },
      });
      isValid = false
      this.spinner.hide("blockLoader");
    } else if (!this.jsonData.category.name) {
      console.log(',,,,,,,')
      this.dialog.open(SuccessComponent, {
        data: {
          title: "Oops!",
          subTitle: "Please Select Category."
        },
      });
      isValid = false
      this.spinner.hide("blockLoader");
    } else if (!this.jsonData.subCategory.name) {
      //   console.log(',,,,,,,')
      this.dialog.open(SuccessComponent, {
        data: {
          title: "Oops!",
          subTitle: "Please select a sub category."
        },
      });
      isValid = false
      this.spinner.hide("blockLoader");
    } else if (this.jsonData.sections.length > 0) {
      for (let i = 0; i < this.jsonData.sections.length; i++) {
        if (!this.jsonData.sections[i].name || !this.jsonData.sections[i].description) {
          this.dialog.open(SuccessComponent, {
            data: {
              title: "Oops!",
              subTitle: "Please fill all details of sections."
            },
          });
          isValid = false;
          this.spinner.hide("blockLoader");
          break;
        }
      }
    } else if (this.jsonData.courseTime) {
      let reg = new RegExp(/^\d{2}:\d{2}$/);
      console.log(reg.test(this.jsonData.courseTime))
      if (!reg.test(this.jsonData.courseTime)) {
        console.log(',,,,,,,')
        this.dialog.open(SuccessComponent, {
          data: {
            title: "Oops!",
            subTitle: "Please Enter correct format(hh:mm) of Course Time."
          },
        });
        isValid = false
        this.spinner.hide("blockLoader");
      }
    }
    // console.log('----', isValid);
    return isValid;
  }

  async saveProgram() {
    // if (this.jsonData.name.trim().length >= 1 && this.jsonData.category.name && this.jsonData.subCategory.name) {

    if (!this.jsonData.name.trim()) {
      this.showAlert("OOPS!", "Program cannot be created until Program Name has been added.");
      return;
    }

    if (!this.jsonData.category?.name) {
      this.showAlert("OOPS!", "Program cannot be created until Category have been added.");
      return;
    }

    if (!this.jsonData.subCategory?.name) {
      this.showAlert("OOPS!", "Program cannot be created until Sub-Category have been added.");
      return;
    }

    await this.spinner.show("blockLoader");
    this.jsonData.programMenuCompleted = true;
    this.jsonData.createdAt = new Date();
    this.jsonData.updatedAt = new Date();
    const res: any = await this._programBuilderMainService.addPrograms('', this.jsonData);
    // console.log('res: ', res);
    if (res && res.status === 'success') {
      // Capture PostHog event when program is successfully created
      const userEmail = localStorage.getItem('username');
      const role = localStorage.getItem('roleId');

      this.postHogService.capture('Create program', {
        'User email': userEmail,
        'device_type': 'Web',
        'role': role,
        'program name': this.jsonData.name
      });

      this.dialogRef.close({
        created: true,
        data: res.data
      });
    }
    await this.spinner.hide("blockLoader");
    // }
    // for (let section of this.jsonData.sections) {
    //   for (let i = 1; i <= section.numberOfUnits; i += 1) {
    //     section.menu.push({
    //       sno: `${section.sno}.${i}`,
    //       name: '',
    //       pts: '',
    //       dfs: '',
    //       type: '',
    //       metadata: '',
    //       downloadUrl: ''
    //     });
    //   }
    // }
    // console.log(this.jsonData);
    // let valid = this.validateFields();
    // if (valid) {

    // }
  }

  private showAlert(title: string, subTitle: string) {
    const alertDialogRef = this.dialog.open(AlertComponent, {
      data: { title, subTitle, hideSaveBtn: true },
      panelClass: "custom-alert-class"
    });

    alertDialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Handle dialog close if needed
      }
    });
  }
}
